import { render, staticRenderFns } from "./knowledgebase.vue?vue&type=template&id=3c2c8064&scoped=true&"
import script from "./knowledgebase.vue?vue&type=script&lang=js&"
export * from "./knowledgebase.vue?vue&type=script&lang=js&"
import style0 from "./knowledgebase.vue?vue&type=style&index=0&id=3c2c8064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2c8064",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2c8064')) {
      api.createRecord('3c2c8064', component.options)
    } else {
      api.reload('3c2c8064', component.options)
    }
    module.hot.accept("./knowledgebase.vue?vue&type=template&id=3c2c8064&scoped=true&", function () {
      api.rerender('3c2c8064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/knowledgebase.vue"
export default component.exports